import classnames from 'classnames';
// @ts-ignore
import { withFormsy } from 'formsy-react';
import React from 'react';
import { Dropdown, Icon, Image } from 'semantic-ui-react';

import icon from '../../../assets/images/Common/icn-search-grey.svg';
import './styles.css';

interface Props {
  getValue: () => any;
  setValue: (val: any) => void;
  className: string;
  placeholder: string;
  options: object[];
  allowEmpty?: boolean;
}

interface State {}

const emptyOption = {
  key: '',
  text: '',
  value: '',
};

class SearchSelectionInput extends React.Component<Props, State> {
  public static defaultProps = {
    allowEmpty: false,
  };

  public handleChange = (event: any, data: any) => {
    const { value } = data;

    this.props.setValue(value);
  };

  public render() {
    const { className, placeholder, options, allowEmpty } = this.props;
    return (
      <div className={classnames('searchselection-container', className)}>
        <div className="search-icon">
          <Icon>
            <Image src={icon} />
          </Icon>
        </div>
        <Dropdown
          inline={true}
          className="searchselection-input"
          value={this.props.getValue()}
          search={true}
          selection={true}
          placeholder={placeholder}
          options={allowEmpty ? [emptyOption, ...options] : options}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

export default withFormsy(SearchSelectionInput);
